<template>
<section class="top">
<pmainVis/>
<pnews/>
<pinfo/>
<pxfd/>
<ppv/>
<pcredit/>
</section>
</template>

<script>
import pmainVis from '@/components/mainVis.vue'
import pnews from '@/components/news.vue'
import pinfo from '@/components/info.vue'
import pxfd from '@/components/xfd.vue'
import ppv from '@/components/pv.vue'
import pcredit from '@/components/credit.vue'



export default {
  name: 'app',
  components: {
    pmainVis,
    pnews,
    pinfo,
    pxfd,
    ppv,
    pcredit
  },
  methods: {
    handleScroll: function (evt, el) {
      let top = el.getBoundingClientRect().top;
      if (window.scrollY > top + window.pageYOffset - window.innerHeight + 300) {
        el.classList.add('is-shown')
        return true
      }
      return false //window.scrollY > 100
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.top{
  //height: 860px;
  position: relative;
  @include mq(){
    padding-top: 66px;
  }
  //width: 100%;
  //top: 0;
 // left: 0;
}

</style>
